export default __webpack_public_path__ + "static/media/38.10a87c88.png";